
// il flusso avrà tre pagine: acquisto (questa), checkout e conferma.
// il nome 'homepage' è obbligatorio: App.vue ci fa il router-link dal logo di header
const prod = [
  {
    path: '/',
    name: 'homepage',
    component: () => import(`${process.env.VUE_APP_SITE_URL}/components/views/homepage.vue`),
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import(`${process.env.VUE_APP_SITE_URL}/components/views/checkout.vue`),
  },
  // la conferma si raggiunge da due strade, come sugli altri site: /confirm è
  // quella dell'acquisto appena concluso, /prenotazioni quella di chi torna su
  // un ordine già emesso. Cambia solo `ignore_redirect`, cioè se rispedire
  // l'utente al portale welfare quando l'integrazione lo prevede
  {
    path: '/confirm/:confirm_code/:gift_voucher_id',
    name: 'confirm',
    component: () => import(`${process.env.VUE_APP_SITE_URL}/components/views/confirm.vue`),
    props: (route) => ({
      confirm_code: route.params.confirm_code,
      gift_voucher_id: route.params.gift_voucher_id,
      ignore_redirect: false,
    }),
  },
  {
    path: '/prenotazioni/:confirm_code/:gift_voucher_id',
    name: 'prenotazioni',
    component: () => import(`${process.env.VUE_APP_SITE_URL}/components/views/confirm.vue`),
    props: (route) => ({
      confirm_code: route.params.confirm_code,
      gift_voucher_id: route.params.gift_voucher_id,
      ignore_redirect: true,
    }),
  },
  {
    path: '/termini-e-condizioni',
    name: 'terms',
    component: () => import(`${process.env.VUE_APP_SITE_URL}/components/views/static-pages/terms.vue`),
  },
]

export {
  prod
}